import "intersection-observer";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { parse } from "qs";

import createBrowserHistory from "history/createBrowserHistory";
import * as hypernova from "hypernova";
import { combineReducers } from "redux";

import configureStore from "./configureStore";
import { BootstrapData } from "./lib/bootstrap";
import { reducerRegistry } from "./lib/ReducerRegistry";
import { mergeEntities } from "./lib/entities";
import commonReducers from "./common/reducers";
import App from "./App";
import { router } from "./routes";
import { initialEntitiesMap } from "./entities";
import { bootstrapped as bootstrappedForAuth } from "./common/actions/Auth";
import { bootstrapped as bootstrappedForExperiments } from "./common/actions/Experiments";

async function main() {
  const results = hypernova.load<BootstrapData>("App");
  if (results.length === 0) {
    return;
  }

  // TODO(KentoMoriwaki): Handle multi entires.
  const { node, data } = results[0];

  const history = createBrowserHistory();

  reducerRegistry.register({ ...commonReducers });

  const defaultRouteInfo = await router.resolve({
    pathname: location.pathname,
    query: parse(location.search, { ignoreQueryPrefix: true }),
    hash: location.hash,
    waitUntilLoaded: true,
  });

  const store = configureStore({ history, reducerRegistry });

  data.body.entities = mergeEntities(initialEntitiesMap, data.body.entities);
  store.dispatch({
    type: `bootstrap/${data.page}`,
    payload: data.body,
  });

  store.dispatch(bootstrappedForAuth(data.auth));
  store.dispatch(bootstrappedForExperiments(data.body));

  reducerRegistry.setChangeListener(reducers => {
    store.replaceReducer(combineReducers(reducers));
  });

  ReactDOM.hydrate(<App {...{ store, history, reducerRegistry, defaultRouteInfo, locale: data.auth.locale }} />, node);

  if (module.hot) {
    module.hot.accept(async () => {
      const defaultRouteInfo = await router.resolve(location);
      ReactDOM.hydrate(
        <App {...{ store, history, reducerRegistry, defaultRouteInfo, locale: data.auth.locale }} />,
        node
      );
    });
  }
}

main().catch(err => {
  // tslint:disable-next-line:no-console
  console.error(err);
});



// WEBPACK FOOTER //
// ./frontend/src/index.tsx